import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748569596141.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "header-menu",
    on: {
      click: function click($event) {
        return _vm.sysClick("辅助管理");
      }
    }
  }, [_c("div", [_vm._v("辅助管理")])]), _vm.accountCategory !== "Business" ? _c("div", {
    staticClass: "lab-select"
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择",
      disabled: ""
    },
    model: {
      value: _vm.labId,
      callback: function callback($$v) {
        _vm.labId = $$v;
      },
      expression: "labId"
    }
  }, _vm._l(_vm.lab_list, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1), _c("div", {
    staticClass: "menu",
    on: {
      click: function click($event) {
        _vm.lab_show = true;
      }
    }
  }, [_c("div", [_vm._v("切换公司")])])], 1) : _vm._e(), _vm._m(0), _c("div", {
    staticClass: "center"
  }, [_c("img", {
    staticClass: "center-bg-1",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748568201040.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "center-bg-2",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748568174556.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "center-bg-3",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748568128483.png",
      alt: ""
    }
  }), _vm._m(1), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("div", [_c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("数字孪生");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908569141.png",
      alt: ""
    }
  }), _vm._m(2)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("智慧物联");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908511033.png",
      alt: ""
    }
  }), _vm._m(3)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("生产调度");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908534078.png",
      alt: ""
    }
  }), _vm._m(4)])]), _c("div", [_c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("驾驶舱");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908593229.png",
      alt: ""
    }
  }), _vm._m(5)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("视频监控");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908624641.png",
      alt: ""
    }
  }), _vm._m(6)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("智能模型");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908640686.png",
      alt: ""
    }
  }), _vm._m(7)])])]), _vm.labInfo.accessRegionCockpit ? _c("div", {
    staticClass: "city",
    on: {
      click: function click($event) {
        return _vm.sysClick("城市驾驶舱");
      }
    }
  }, [_c("img", {
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260805/1785898754845.png",
      alt: ""
    }
  }), _c("div", [_vm._v("城市驾驶舱")])]) : _vm._e(), _c("div", {
    staticClass: "right"
  }, [_c("div", [_c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("能耗管控");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908666567.png",
      alt: ""
    }
  }), _vm._m(8)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("质量溯源");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908683962.png",
      alt: ""
    }
  }), _vm._m(9)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("病害防疫");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908707530.png",
      alt: ""
    }
  }), _vm._m(10)])]), _c("div", [_c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("范蠡大模型");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908730036.png",
      alt: ""
    }
  }), _vm._m(11)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("精准投喂");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908750755.png",
      alt: ""
    }
  }), _vm._m(12)]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.sysClick("自动巡检");
      }
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: "https://oss-mng.rich-link.cn/undefined/20260713/1783908770313.png",
      alt: ""
    }
  }), _vm._m(13)])])])])]), _c("img", {
    staticClass: "bottom",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748568350779.png",
      alt: ""
    }
  }), _vm.lab_show ? _c("labSel", {
    on: {
      "child-lab-sel": _vm.labSel
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "header"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: require("./image/header-1.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")]), _c("img", {
    staticClass: "header-2",
    attrs: {
      src: require("./image/header-2.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "center-bottom"
  }, [_c("img", {
    staticClass: "left",
    attrs: {
      src: require("./image/left.png"),
      alt: ""
    }
  }), _c("img", {
    staticClass: "right",
    attrs: {
      src: require("./image/right.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("数字孪生")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧物联")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("生产调度")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("驾驶舱")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("视频监控")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智能模型")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("能耗管控")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("质量溯源")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("病害防疫")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("范蠡大模型")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("精准投喂")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text"
  }, [_c("img", {
    attrs: {
      src: require("./image/text.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("自动巡检")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };